import * as axios from 'axios'

export default class Api {
  constructor() {
    this.api_token = null
    this.client = null
    this.api_url = process.env.REACT_APP_BASE_API_URL
  }

  init = () => {
    this.api_token = localStorage.getItem('apiToken')

    let headers = {
      Accept: 'application/json',
    }

    if (this.api_token) {
      headers.Authorization = `Bearer ${this.api_token}`
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
      // responseType: "blob",
    })

    return this.client
  }

  login(data) {
    return this.init().post('/auth/login-tesis', data)
  }

  changePassword(data) {
    return this.init().post('/change-password', data)
  }

  register(data) {
    return this.init().post('/auth/register-tesis', data)
  }

  getScientificField = (params) => {
    return this.init().get('/list/bidang-keilmuan', {params})
  }

  getThesis = (params) => {
    return this.init().get('/list/tesis', {params})
  }

  getThesisAdmin = (params) => {
    return this.init().get('/list/tesis/admin', {params})
  }

  getThesisDetail = (id) => {
    return this.init().get(`/detail/tesis/${id}`)
  }

  getTotalThesis = () => {
    return this.init().get(`/list/total-tesis`)
  }

  getLanguage = (params) => {
    return this.init().get(`/list/bahasa`, {params})
  }

  getThesisFeedback = (thesisId) => {
    return this.init().get(`/list/feedback/${thesisId}`)
  }

  forgotPassword = (data) => {
    return this.init().post('/auth/forgot-password', data)
  }

  storeThesisFeedback = (data) => {
    return this.init().post('/tesis/feedback', data)
  }

  registerThesis = (data) => {
    return this.init().post('/register-peneliti-tesis', data)
  }

  getTotalThesisPublic = () => {
    return this.init().get('/list/total-tesis-publik')
  }

  getTotalScolarship = () => {
    return this.init().get('/list/total/beasiswa')
  }

  getMasterTable = (params) => {
    return this.init().get('/list/master/table', {params})
  }

  getThesisFile = (id) => {
    return this.init().get(`/detail/tesis/enkrip/${id}`)
  }

  getProfile = () => {
    return this.init().get(`/profile/v2`)
  }

  getPublishDate = () => {
    return this.init().get(`/list/tesis/date/publish`)
  }

  getCountry = () => {
    return this.init().get(`/list/tesis/country/publish`)
  }

  storeMasterTable = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/master/table`, formData)
  }

  updateMasterTable = (data, id) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/master/table/${id}`, formData)
  }

  updateFotoProfile = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`user/user_detail/upload-image-tesis`, formData)
  }

  // PANA
  addMember = (data) => {
    return this.init().post(`/pana/tambah/anggota`, data)
  }

  getRegisterPana = () => {
    return this.init().get(`/pana/detail-pendaftaran`)
  }

  registerPana = (data) => {
    return this.init().post(`/pana/store`, data)
  }

  uploadFile = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/pana/tambah/file`, formData)
  }

  statementLetter = (data) => {
    return this.init().post(`pana/surat-pernyataan`, data)
  }

  deleteMember = (data) => {
    return this.init().post(`/pana/hapus/anggota`, data)
  }

  profileByEmail = (data) => {
    return this.init().post(`/pana/data-by-email`, data)
  }

  checkPana = (data) => {
    return this.init().get(`/pana/check`, data)
  }

  updateProfile = (data) => {
    return this.init().post(`/pana/pembaruan-profile`, data)
  }

  getThemeList = () => {
    return this.init().get(`/pana/list`)
  }

  themeListByLocus = (data) => {
    return this.init().post(`/pana/tema-locus`, data)
  }

  checkTeams = () => {
    return this.init().get(`/pana/check-anggota`)
  }

  checkAgreementLetter = () => {
    return this.init().get(`/pana/check-surat-pernyataan`)
  }

  deletePana = (data) => {
    return this.init().post(`/pana/cancel`, data)
  }

  getCOPHome = () => {
    return this.init().get(`/cop/home`)
  }

  getCOPCategories = () => {
    return this.init().get(`/cop/kategori-berita`)
  }

  getCOPNews = (id) => {
    return this.init().get(`/cop/home/berita/${id}`)
  }

  getCOPDetail = (id) => {
    return this.init().get(`/cop/berita/view/${id}`)
  }

  getCOPDetailShare = (id) => {
    return this.init().get(`/cop/berita/share/${id}`)
  }
}
